import Api from '@/services/Api';

export default {
  getCookie() {
    return Api.get('/sanctum/csrf-cookie');
  },
};
